const TIME = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
const END = /^(?:(?:[01]\d|2[0-3]):[0-5]\d|24:00)$/;
const minutes = (value: string) => {
  const [hours = 0, mins = 0] = value.split(':').map(Number);
  return hours * 60 + mins;
};

/** Wall-clock intervals, anchored to this day's opening, including overnight hours. */
export function isOrderWindowWithinHours(
  open: string,
  close: string,
  from = '',
  to = '',
): boolean {
  if (!from && !to) return true;
  if (!TIME.test(open) || !END.test(close) || !TIME.test(from) || !END.test(to))
    return false;
  const start = minutes(open);
  let end = minutes(close);
  if (end <= start) end += 1440;
  let orderStart = minutes(from);
  if (orderStart < start) orderStart += 1440;
  let orderEnd = minutes(to);
  if (orderEnd <= orderStart) orderEnd += 1440;
  return orderStart >= start && orderEnd > orderStart && orderEnd <= end;
}
